/* ============================================================================
   Firebase - initialization
   ----------------------------------------------------------------------------
   NOTE: The browser loads these files directly (no bundler), so we import the
   Firebase SDK from the gstatic CDN with full URLs. Do NOT use bare imports
   like `from "firebase/app"` here - the browser can't resolve those without a
   build step, and it breaks every page that depends on this file.

   The `firebaseConfig` values below are yours (safe to expose for a web app).
   As soon as apiKey + projectId are present, the app runs in live mode.
   ============================================================================ */

import { initializeApp } from "https://www.gstatic.com/firebasejs/10.12.2/firebase-app.js";
import { getAuth } from "https://www.gstatic.com/firebasejs/10.12.2/firebase-auth.js";
import { getFirestore } from "https://www.gstatic.com/firebasejs/10.12.2/firebase-firestore.js";
import { getFunctions } from "https://www.gstatic.com/firebasejs/10.12.2/firebase-functions.js";
import { getStorage } from "https://www.gstatic.com/firebasejs/10.12.2/firebase-storage.js";

export const firebaseConfig = {
  apiKey: "AIzaSyCkPl2Seg-E9dFnTY6-JM0ExWsNrdK3vug",
  authDomain: "cookiecodejar.firebaseapp.com",
  projectId: "cookiecodejar",
  storageBucket: "cookiecodejar.firebasestorage.app",
  messagingSenderId: "875472955266",
  appId: "1:875472955266:web:6cf62d80ff7381d100519b",
  measurementId: "G-3XNCN4GN2B",
};

/**
 * Your live domain from Spaceship - fill in after Firebase Hosting is connected.
 * Example: "cookiecodejar.com" (no https://, no www)
 * Leave empty to use the default *.firebaseapp.com URL.
 */
export const CUSTOM_DOMAIN = "cookiecodejar.com";

/** Public site URL - used for email verification links (www is the live host). */
export const SITE_URL = CUSTOM_DOMAIN
  ? `https://www.${CUSTOM_DOMAIN}`
  : `https://${firebaseConfig.authDomain}`;

/** Firebase Auth email action settings (verification links open our branded page). */
export function emailActionSettings() {
  return {
    url: `${SITE_URL}/verify-email.html`,
    handleCodeInApp: true,
  };
}

/** Password reset links open our branded reset page. */
export function passwordResetActionSettings() {
  return {
    url: `${SITE_URL}/reset-password.html`,
    handleCodeInApp: true,
  };
}

// True once apiKey + projectId are present.
export const isConfigured = Boolean(firebaseConfig.apiKey && firebaseConfig.projectId);

// Exported instances used across the app.
export let app = null;
export let auth = null;
export let db = null;
export let functions = null;
export let storage = null;

if (isConfigured) {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  functions = getFunctions(app, "us-central1");
  storage = getStorage(app);
} else {
  console.warn(
    "%c[CookieCodeJar] Preview mode - Firebase isn't configured yet.\n" +
      "Add your keys to js/firebase-config.js to go live.",
    "color:#d4a017"
  );
}
